export const PINNED_LEADING_EDITOR_LEFT_CSS_VARIABLE =
  '--database-pinned-leading-editor-left';
export const PINNED_LEADING_EDITOR_RIGHT_CSS_VARIABLE =
  '--database-pinned-leading-editor-right';
export const PINNED_LEADING_EDITOR_STICKY_ATTRIBUTE =
  'data-dbs-pinned-leading-editor-sticky';

const PINNED_LEADING_TABLE_SELECTOR = '[data-dbs-pinned-leading-active="true"]';
const PINNED_LEADING_BOUNDARY_CELL_SELECTOR =
  ':scope > td[data-dbs-pinned-leading-boundary="true"]';
const SCROLLABLE_CONTAINER_SELECTOR = '[data-testid="scrollable-inner-container"]';

export function revealCellEditorAfterPinnedLeadingColumns(
  cell: HTMLTableCellElement
): void {
  cell.removeAttribute(PINNED_LEADING_EDITOR_STICKY_ATTRIBUTE);
  cell.style.removeProperty(PINNED_LEADING_EDITOR_LEFT_CSS_VARIABLE);
  cell.style.removeProperty(PINNED_LEADING_EDITOR_RIGHT_CSS_VARIABLE);

  if (!cell.closest(PINNED_LEADING_TABLE_SELECTOR)) {
    return;
  }

  const boundaryCell = cell.parentElement?.querySelector<HTMLTableCellElement>(
    PINNED_LEADING_BOUNDARY_CELL_SELECTOR
  );
  const scrollableContainer = cell.closest<HTMLElement>(SCROLLABLE_CONTAINER_SELECTOR);
  if (!boundaryCell || !scrollableContainer) {
    return;
  }

  const boundaryRect = boundaryCell.getBoundingClientRect();
  const containerRect = scrollableContainer.getBoundingClientRect();
  const cellRect = cell.getBoundingClientRect();
  const editorLeftPx = Math.max(boundaryRect.right, cellRect.left);
  const stickyLeftPx = Math.max(0, editorLeftPx - containerRect.left);
  const stickyRightPx = Math.max(0, containerRect.right - editorLeftPx - cellRect.width);
  cell.style.setProperty(PINNED_LEADING_EDITOR_LEFT_CSS_VARIABLE, `${stickyLeftPx}px`);
  cell.style.setProperty(PINNED_LEADING_EDITOR_RIGHT_CSS_VARIABLE, `${stickyRightPx}px`);
  cell.setAttribute(PINNED_LEADING_EDITOR_STICKY_ATTRIBUTE, 'true');

  const overlapPx = boundaryRect.right - cellRect.left;
  if (overlapPx <= 0) {
    return;
  }

  scrollableContainer.scrollTo({
    left: Math.max(0, scrollableContainer.scrollLeft - overlapPx),
    behavior: 'smooth'
  });
}
